export const bookingCharges = {
  header: {
    title: "الرسوم",
    titleNew: "رسوم جديدة",
    sub: "البنود التي ستُدرَج في فاتورة النزيل.",
    subNew:
      "للفاتورة التالية. الإقامة التي صدرت فاتورتها معروضة بالأعلى ضمن فاتورتها.",
  },
  loading: "جارٍ تحميل الرسوم…",
  empty: {
    title: "لا توجد رسوم مسجلة",
    titleBilled: "لا توجد رسوم معلّقة",
    sub: "أضف الإقامة أو التنظيف أو الإضافات أو خدمات أخرى.",
    subBilled: "أضف رسمًا لإنشاء فاتورة أخرى لهذا الحجز.",
  },
  buttons: {
    addCharge: "إضافة رسم",
    addFirstCharge: "إضافة أول رسم",
    manage: "إدارة",
    manageTemplatesTitle: "إدارة القوالب",
    add: "إضافة",
    close: "إغلاق",
    cancel: "إلغاء",
    saving: "جارٍ الحفظ…",
    saveCharge: "حفظ الرسم",
    saveChanges: "حفظ التغييرات",
    deleting: "جارٍ الحذف…",
    confirmDelete: "نعم، احذف",
    editTitle: "تعديل",
    deleteTitle: "حذف",
  },
  table: {
    item: "الصنف",
    qty: "الكمية",
    unitPrice: "سعر الوحدة",
    vat: "ض.ق.م",
    total: "الإجمالي",
  },
  chips: {
    lodging: "الإقامة",
    discount: "خصم",
    autoSynced: "مُزامَن تلقائيًا",
  },
  // Resumen de la estancia bajo cada habitación.
  stay: {
    nights: "ليلة واحدة | {n} ليالٍ",
    rooms: "غرفة واحدة | {n} غرف",
  },

  fields: {
    // De qué habitación es el cargo (reservas de varias habitaciones).
    room: "الغرفة",
    roomAll: "الحجز بالكامل",
    roomHint: "إذا كان لغرفة بعينها، فسيظهر في فاتورة تلك الغرفة.",
    date: "التاريخ",
    category: "الفئة",
    quantity: "الكمية",
    unitPriceFull: "سعر الوحدة",
    vatPct: "ض.ق.م (%)",
    name: "الاسم",
    price: "السعر",
    internalNotes: "ملاحظات داخلية",
    paymentMethod: "طريقة الدفع",
    paymentDate: "تاريخ الدفع",
    guestCount: "عدد النزلاء",
  },
  placeholders: {
    item: "اختر أو اكتب بندًا…",
    egCleaning: "مثال: تنظيف",
    internalNote: "أضف ملاحظة داخلية…",
  },
  templates: {
    savedTitle: "الرسوم المحفوظة",
    noResults: 'لا نتائج لـ "{query}"',
    emptyPre: "لا توجد رسوم محفوظة. ",
    createOne: "أنشئ واحدًا",
    manageTitle: "رسوم مخصّصة",
    manageSub: "أنشئ رسومًا قابلة لإعادة الاستخدام لفواتيرك.",
    emptyList: "لا توجد رسوم محفوظة. أضف أول واحد بالأعلى.",
    noCategory: "بدون فئة",
  },
  vat: {
    labelPct: "ض.ق.م {rate}٪",
  },
  modal: {
    editTitle: "تعديل الرسم",
    addSub: "بند جديد للفاتورة",
    editSub: "عدّل بيانات الرسم",
    totalCalculated: "الإجمالي المحسوب",
  },
  common: {
    optional: "(اختياري)",
    unspecified: "غير محدد",
  },
  invoice: {
    sectionLabel: "فاتورة إلكترونية",
  },
  footer: {
    pending: "في انتظار إصدار الفاتورة",
    totalDue: "الإجمالي المستحق",
  },
  deleteModal: {
    title: "حذف الرسم؟",
    sub: "لا يمكن التراجع عن هذا الإجراء.",
  },
  autoCategory: {
    service: "خدمة",
    fee: "رسم",
    extraGuest: "نزيل إضافي",
    tax: "ضريبة",
    cityTax: "ضريبة سياحية",
    adjustment: "تسوية",
    autoFallback: "رسم تلقائي",
  },
  chargeBasis: {
    percentOfTotal: "نسبة من الإجمالي",
    perNight: "لكل ليلة",
    perPerson: "لكل شخص",
    perPersonPerNight: "لكل شخص وليلة",
    perStay: "لكل حجز",
  },
  toast: {
    descRequired: "الوصف مطلوب.",
    chargeAdded: "تمت إضافة الرسم.",
    chargeUpdated: "تم تحديث الرسم.",
    chargeDeleted: "تم حذف الرسم.",
    chargeSaved: "تم حفظ الرسم.",
    saveFailed: "تعذّر الحفظ.",
    deleteFailed: "تعذّر الحذف.",
    warningTitle: "تنبيه",
    doneTitle: "تم",
    errorTitle: "خطأ",
  },
  invoices: {
    title: "الفواتير الصادرة",
    noName: "بدون اسم",
    conceptCount: "{count} بند | {count} بنود",
    viewPdf: "عرض PDF",
    sendWhatsapp: "إرسال عبر واتساب",
    correct: "تصحيح (فاتورة تصحيحية)",
    void: "إلغاء (فاتورة تصحيحية)",
    conceptsFoot:
      "هذه البنود صدرت بها فاتورة بالفعل. يحتوي ملف PDF على التفاصيل الكاملة.",
  },
  status: {
    draft: "مسودة",
    sent: "صادرة",
    processing: "قيد المعالجة",
    pending: "معلّقة",
    error: "خطأ",
    corrected: "مصحّحة",
    voided: "ملغاة",
  },
  checkinModal: {
    title: "معلومات التسجيل",
    bookingLink: "الحجز رقم {code}",
    requestDate: "تاريخ الطلب: {date} في {time}",
  },
  payment: {
    desti: "الدفع عند الوصول",
    efect: "نقدًا",
    movil: "الدفع عبر الجوال",
    otro: "وسائل دفع أخرى",
    platf: "منصة دفع",
    tarjt: "بطاقة ائتمان",
    trans: "تحويل بنكي",
    treg: "بطاقة هدية",
  },
};
